import { composeValidators } from 'utils/validators';
import { StyledField, StyledGrid, StyledLabel } from '../ui';
import { FormFormattedField, FormInput } from 'components';
import { normalizeFormattedField } from 'utils';
import { useField, useForm } from 'react-final-form';
import moment from 'moment';
import { useSelector } from 'react-redux';
import { useIsAlternativeAuction } from 'hooks';
import { AUCTION_TYPES, roles } from 'constants';
import { useCallback, useRef } from 'react';
import { Vehicle } from 'types/vehicle';
import { useFocusOnRender } from '../hooks';
import { useUpdateStartingBid } from 'hooks/useUpdateStartingBid';
import { useReservePriceValidation } from 'hooks/useGetValidators';

export const ReservePriceField = () => {
  const form = useForm();
  const { values } = form.getState();

  const ref = useRef<HTMLInputElement>(null);
  useFocusOnRender(ref, 'reserve_price');

  const vehicleTimeEnded = values?.date_end && moment(values.date_end).isBefore(moment());
  const userRole = useSelector((state: any) => state?.user?.user?.role);
  const vehicleReservedPriceMet = values?.reserve_price_met;

  const isAlternativeAuction = useIsAlternativeAuction(values as Vehicle);
  const isScAuction = values.auction && values.auction.type === AUCTION_TYPES.SECOND_CHANCE;

  const {
    input: { value: alternativeOffer },
    meta
  } = useField('alternative_offer');

  const { input: startingBidInput } = useField('starting_bid');

  const updateStartingBid = useCallback((newStartingBid: number) => startingBidInput.onChange(newStartingBid), []);

  useUpdateStartingBid(alternativeOffer, updateStartingBid, {
    skip: !isScAuction || !meta.dirty || vehicleReservedPriceMet
  });

  const auctionType = values.auction?.type || AUCTION_TYPES.AUTOAXESS;
  const validateReserve = useReservePriceValidation(auctionType);

  const fieldDisabled = (() => {
    if (userRole === roles.ADMIN) return false;
    if (isAlternativeAuction) return vehicleReservedPriceMet;
    return vehicleTimeEnded || vehicleReservedPriceMet;
  })();

  return (
    <StyledGrid item xs={12}>
      <StyledLabel>Reserve price</StyledLabel>
      <StyledField
        inputRef={ref}
        name="reserve_price"
        component={FormFormattedField}
        placeholder=""
        // @ts-ignore
        thousandSeparator
        allowNegative={false}
        fixedDecimalScale
        prefix="$"
        customInput={FormInput}
        disableUnderline
        parse={normalizeFormattedField}
        validate={composeValidators(...validateReserve)}
        disabled={fieldDisabled}
      />
    </StyledGrid>
  );
};
